var exports = {
  "x6": "button__dsQ7YP",
  "q3": "indicator__ilNujn",
  "Qq": "text__anyfSw",
};

module.exports = exports;
